import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
var render = function render() {
  var _vm$order$payments, _vm$listTerms$find$na, _vm$listTerms$find, _vm$order, _vm$order2, _vm$itemsRequiringTas;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    style: _vm.orderCtaStyles
  }, [_vm.hasMissingLogisticCost ? [_c("Error", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      error: {
        title: "An error occured",
        description: "It seems that we can`t find any shipping methhod available for this order. Sorry for the inconvenience.",
        linkTitle: "Go back",
        link: "userOrderList",
        params: {
          tab: "orders"
        }
      }
    }
  })] : [_vm.isDocumentsConsultable ? _c("div", {
    staticClass: "order-top-buttons"
  }, [_c(VDialog, {
    attrs: {
      scrollable: "",
      width: "40rem"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VBtn, _vm._g(_vm._b({
          staticClass: "dfwa-btn --small",
          attrs: {
            loading: _vm.loadingDocuments,
            disabled: _vm.loadingDocuments || !_vm.documents.length,
            rounded: true
          }
        }, "v-btn", attrs, false), on), [_vm._v(" Documents (" + _vm._s(_vm.documentCount) + ") ")])];
      }
    }], null, false, 215265207),
    model: {
      value: _vm.documentDialog,
      callback: function callback($$v) {
        _vm.documentDialog = $$v;
      },
      expression: "documentDialog"
    }
  }, [_c(VCard, [_c(VCardTitle, [_vm._v("Documents")]), _c(VDivider), _c(VCardText, [_c(VTreeview, {
    attrs: {
      items: _vm.documents,
      "open-on-click": "",
      "item-key": "name"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn(_ref2) {
        var item = _ref2.item,
          open = _ref2.open;
        return [!item.url ? _c("div", {
          staticClass: "d-flex align-center"
        }, [_c(VIcon, [_vm._v(" " + _vm._s(open ? "mdi-folder-open" : "mdi-folder") + " ")]), _c("span", [_vm._v(_vm._s(item.name) + " (" + _vm._s(item.children.length) + ")")])], 1) : _c("div", {
          on: {
            click: function click($event) {
              return _vm.openDocument(item);
            }
          }
        }, [_c("a", [_vm._v(_vm._s(item.name))])])];
      }
    }], null, false, 1498402482)
  })], 1), _c(VDivider), _c(VCardActions, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        _vm.documentDialog = false;
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1) : _vm._e(), _vm.order.status == _vm.orderStatus.find(function (x) {
    return x.id == "AWAITING_CUSTOMER_VALIDATION";
  }).status ? _c("div", {
    staticClass: "mb-4 text-smaller text-italic text-center"
  }, [_c("span", {
    staticClass: "router-link",
    on: {
      click: function click($event) {
        return _vm.scrollTo(".button-end-page-container");
      }
    }
  }, [_vm._v(" If you agree with " + _vm._s(_vm.adjustments.length > 0 ? "this adjustment" : "this order") + ", please scroll down to the bottom of page, and use the button " + _vm._s(_vm.order.payments.length || _vm.isImporterPreventPayment || _vm.isStoredInbound ? '"Confirm order"' : '"Continue to payment"') + " ")])]) : _vm._e(), _c("div", {
    staticClass: "container-centered small text-left"
  }, [_vm.order.items.length == 0 ? _c("div", [_c("h3", {
    staticClass: "text-center"
  }, [_vm._v("This order is empty")])]) : _c("div", {
    staticClass: "order-maincontent"
  }, [_c("div", {
    staticClass: "order-maincontent-data"
  }, [_c("div", {
    staticClass: "order-maincontent-data-top --one-column"
  }, [_c("div", {
    staticClass: "bold"
  }, [_vm._v(" " + _vm._s(_vm.order.reference_order.shorterReference()) + " "), _vm.isImporterInvoiceConsultable ? _c("span", {
    staticClass: "order-maincontent-data-top-invoicenumber"
  }, [_vm._v(" (" + _vm._s(_vm.order.importerInvoiceNumberLabel) + ") ")]) : _vm.isInvoiceConsultable ? _c("span", {
    staticClass: "order-maincontent-data-top-invoicenumber"
  }, [_vm._v(" (" + _vm._s(_vm.order.invoiceNumberLabel) + ") ")]) : _vm.hasBeenValidated && _vm.order.isPreventInvoice ? _c("span", {
    staticClass: "order-maincontent-data-top-invoicenumber"
  }, [_vm._v(" (" + _vm._s(_vm.getOrderConfirmationReference(_vm.order)) + ") ")]) : _vm._e()]), _c("div", {
    staticClass: "order-maincontent-data-top-date"
  }, [_c("span", [_c("i", {
    staticClass: "fas fa-calendar-alt"
  }), _vm._v(" " + _vm._s(_vm._f("formatDate")(_vm.order.date_order)) + " ")])])]), _vm.order.shipment_date ? _c("div", {
    staticClass: "order-maincontent-data-shippingdata"
  }, [_vm.order.shipment_date ? _c("div", [_vm._m(0), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_vm._v(" " + _vm._s(new Intl.DateTimeFormat("en-GB", {
    dateStyle: "full"
  }).format(new Date(_vm.order.shipment_date))) + " ")])]) : _vm._e()]) : _vm._e(), _c("div", [_c("div", [_vm._m(1), _c("div", {
    staticClass: "order-maincontent-data-value",
    attrs: {
      "data-cy": "order-status-read"
    }
  }, [_c("span", {
    class: ["badge --bigger line-height-1_1", _vm.order.status === _vm.orderStatus.find(function (x) {
      return x.id === "CANCELLED";
    }).status ? "danger" : "success"]
  }, [_vm._v(" " + _vm._s(_vm.orderStatus.find(function (x) {
    return x.status === _vm.order.status;
  }).valueBuyer) + " ")]), _c("span", {
    staticClass: "text-smaller ml-1"
  }, [_vm._v(" (" + _vm._s(_vm._f("formatDate")(_vm.order.lastStatusUpdateDate)) + ") ")])])])]), _c("div", [_c("div", [_vm._m(2), _c("div", {
    class: ["order-maincontent-data-value"],
    domProps: {
      innerHTML: _vm._s(_vm.userData)
    }
  })]), _c("div", [_vm._m(3), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_c("div", [_vm._v(_vm._s(_vm.order.user.phone))]), _c("div", [_vm._v(_vm._s(_vm.order.user.login))])])])]), !_vm.isStoredInbound ? _c("div", {
    staticClass: "withBeforeSeparator"
  }, [(_vm$order$payments = _vm.order.payments) !== null && _vm$order$payments !== void 0 && _vm$order$payments.length ? _c("div", [_vm.order.status != _vm.orderStatus.find(function (x) {
    return x.id == "CANCELLED";
  }).status && (_vm.order.payment_state === _vm.paymentState.SUCCEEDED || _vm.order.payment_state === _vm.paymentState.FAILED) ? _c("PaymentBadgeMulti", {
    staticClass: "inline-block mr-2",
    attrs: {
      payments: _vm.order.payments,
      state: _vm.order.payment_state,
      date: _vm.order.payment_date,
      suffix: _vm.order.buyer_term ? "- ".concat(_vm.listTerms.find(function (x) {
        return x.id === _vm.order.buyer_term;
      }).name) : null
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.isOrderForHoreca ? _c("div", [_vm._m(4), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_c("div", [_vm._v(" " + _vm._s((_vm$listTerms$find$na = (_vm$listTerms$find = _vm.listTerms.find(function (pt) {
    return pt.id == _vm.order.buyer_term;
  })) === null || _vm$listTerms$find === void 0 ? void 0 : _vm$listTerms$find.name) !== null && _vm$listTerms$find$na !== void 0 ? _vm$listTerms$find$na : "Undefined") + " ")])])]) : _vm._e()]) : _vm._e(), !_vm.isOrderAwaitingCustomerValidation && !!_vm.order.expedition_method ? _c("div", {
    staticClass: "order-maincontent-data-shipphingmethod withBeforeSeparator"
  }, [_c("div", [_vm._m(5), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_c("div", [_vm._v(" " + _vm._s(_vm.order.shipmentLabel) + " ")]), _c("div", {
    staticClass: "order-maincontent-data-value order-maincontent-data-value-eta"
  }, [_vm.order.expedition_method !== _vm.expeditionMethods.CELLAR_STORAGE.id ? _c("div", [_vm._v(" Estimated time of arrival, from warehouse departure : " + _vm._s(_vm.getEtaLabel(_vm.order.eta_min_hours, _vm.order.eta_max_hours)) + " ")]) : _vm._e()])])])]) : _vm._e(), _vm.isStoredInbound ? _c("div", {
    class: ["order-maincontent-data-address", !(!_vm.isOrderAwaitingCustomerValidation && !!_vm.order.expedition_method) && "withBeforeSeparator"]
  }, [_c(VCheckbox, {
    staticStyle: {
      "margin-bottom": "-1rem !important",
      width: "fit-content"
    },
    attrs: {
      readonly: true,
      label: "Stored inbound"
    },
    model: {
      value: _vm.isStoredInbound,
      callback: function callback($$v) {
        _vm.isStoredInbound = $$v;
      },
      expression: "isStoredInbound"
    }
  })], 1) : _vm._e(), _vm.isStoredInbound ? [_c("div", {
    staticClass: "order-maincontent-data-address"
  }, [_c("div", [_vm._m(6), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_c("adress", {
    ref: "billingAddress",
    attrs: {
      baseModel: _vm.order.billing_address,
      listCountries: _vm.listCountries,
      listStates: _vm.listStates,
      readOnly: _vm.isShipped || !_vm.isEditingAddresses
    }
  })], 1), !_vm.isShipped ? _c("div", {
    staticClass: "order-maincontent-data-address-btn-container mt-2"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary --small order-maincontent-data-address-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        _vm.isEditingAddresses ? _vm.cancelBillingAddress() : _vm.editBillingAddress();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isEditingAddresses ? "Cancel" : "Edit billing address") + " ")]), _vm.isEditingAddresses ? _c(VBtn, {
    staticClass: "dfwa-btn secondary --small order-maincontent-data-address-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: _vm.saveAddress
    }
  }, [_vm._v(" Save ")]) : _vm._e()], 1) : _vm._e()])])] : [_c("div", {
    class: ["order-maincontent-data-address", !(!_vm.isOrderAwaitingCustomerValidation && !!_vm.order.expedition_method) && "withBeforeSeparator"]
  }, [!_vm.hasBeenValidated && !_vm.sameAddress ? _c("div", {
    staticStyle: {
      "grid-column": "2 / 2"
    }
  }, [_c(VCheckbox, {
    staticStyle: {
      "margin-bottom": "-1rem !important"
    },
    attrs: {
      id: "sameAddress",
      label: "Billing address is identical",
      readonly: !_vm.isEditingAddresses
    },
    on: {
      change: function change($event) {
        return _vm.addressChange();
      }
    },
    model: {
      value: _vm.sameAddress,
      callback: function callback($$v) {
        _vm.sameAddress = $$v;
      },
      expression: "sameAddress"
    }
  })], 1) : _vm._e(), _c("div", [_vm._m(7), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_c("adress", {
    ref: "deliveryAddress",
    attrs: {
      baseModel: _vm.order.delivery_address,
      listCountries: _vm.listCountries,
      listStates: _vm.listStates,
      readOnly: _vm.hasBeenValidated || !_vm.isEditingAddresses,
      disabledCountry: true,
      disabledState: true,
      countryTooltipMessage: "You cannot change the country of delivery at this stage because some of the wines are only available in this country."
    },
    on: {
      change: function change($event) {
        return _vm.addressChange();
      }
    }
  })], 1)]), _c("div", [_vm._m(8), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_vm.hasBeenValidated || _vm.sameAddress == false ? _c("adress", {
    ref: "billingAddress",
    attrs: {
      baseModel: _vm.order.billing_address,
      listCountries: _vm.listCountries,
      listStates: _vm.listStates,
      readOnly: _vm.hasBeenValidated || !_vm.isEditingAddresses
    },
    on: {
      change: function change($event) {
        return _vm.addressChange();
      }
    }
  }) : _vm._e(), !_vm.hasBeenValidated && _vm.sameAddress ? _c("div", [_c(VCheckbox, {
    attrs: {
      id: "sameAddress",
      label: "Billing address is identical",
      readonly: !_vm.isEditingAddresses
    },
    on: {
      change: function change($event) {
        return _vm.addressChange();
      }
    },
    model: {
      value: _vm.sameAddress,
      callback: function callback($$v) {
        _vm.sameAddress = $$v;
      },
      expression: "sameAddress"
    }
  })], 1) : _vm._e()], 1)]), !_vm.hasBeenValidated ? _c("div", {
    staticClass: "order-maincontent-data-address-btn-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary --small order-maincontent-data-address-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        _vm.isEditingAddresses ? _vm.cancelAddresses() : _vm.editAddresses();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isEditingAddresses ? "Cancel" : "Edit addresses") + " ")]), _vm.isEditingAddresses ? _c(VBtn, {
    staticClass: "dfwa-btn secondary --small order-maincontent-data-address-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: _vm.saveAddress
    }
  }, [_vm._v(" Save ")]) : _vm._e()], 1) : _vm._e()])], _vm.deliveryAddressFaultedMessage ? _c("div", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.deliveryAddressFaultedMessage) + " ")]) : _vm._e(), _c("div", {
    staticClass: "delivery-instructions"
  }, [_c("div", [_vm._m(9), _c("div", {
    staticClass: "mb-2"
  }, [!_vm.isStoredInbound && (_vm.isShippingEditable || _vm.order.stockTransferIsAskedByUser) ? _c(VCheckbox, {
    attrs: {
      readonly: !_vm.isShippingEditable,
      label: "Request to be stored inbound",
      "hide-details": "auto"
    },
    model: {
      value: _vm.order.stockTransferIsAskedByUser,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "stockTransferIsAskedByUser", $$v);
      },
      expression: "order.stockTransferIsAskedByUser"
    }
  }) : _vm._e()], 1), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [!_vm.editingDeliveryInstructions ? [_c("div", {
    staticClass: "flex --baseline"
  }, [_c("div", {
    staticClass: "text-smaller",
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.order.delivery_instructions) || "No instruction")
    }
  }), _vm.deliveryInstructionsEditable ? _c(VIcon, {
    staticClass: "fa fa-pen text-sm ml-2 icon-link",
    on: {
      click: _vm.startEditDeliveryInstructions
    }
  }) : _vm._e()], 1)] : [_c(VTextarea, {
    ref: "inputDeliveryInstruction",
    staticClass: "delivery-instructions-textarea",
    attrs: {
      rows: "3",
      filled: "",
      placeholder: "Write your instructions here",
      "hide-details": "auto"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) return null;
        $event.preventDefault();
        return _vm.updateDeliveryInstructions.apply(null, arguments);
      }
    },
    model: {
      value: _vm.order.delivery_instructions,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "delivery_instructions", $$v);
      },
      expression: "order.delivery_instructions"
    }
  }), _c(VCheckbox, {
    attrs: {
      label: "Save for next purchases"
    },
    model: {
      value: _vm.isSetDeliveryAddressAsDefaultForUserAddress,
      callback: function callback($$v) {
        _vm.isSetDeliveryAddressAsDefaultForUserAddress = $$v;
      },
      expression: "isSetDeliveryAddressAsDefaultForUserAddress"
    }
  }), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.updateDeliveryInstructions
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-arrow-right",
    staticStyle: {
      "margin-right": "0.25rem"
    },
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Save delivery instructions ")], 1)]], 2)])]), _c("div", {
    staticClass: "--one-column"
  }, [_c("div", {
    staticClass: "order-maincontent-data-total"
  }, [_c("div", [!_vm.order.isFullyCalculatedAmounts ? [_c(VMenu, {
    attrs: {
      "open-on-hover": "",
      top: "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var on = _ref3.on,
          attrs = _ref3.attrs;
        return [_c(VIcon, _vm._g(_vm._b({
          attrs: {
            color: "orange darken-2"
          }
        }, "v-icon", attrs, false), on), [_vm._v("mdi-alert")])];
      }
    }], null, false, 4104483039)
  }, [_c(VCard, {
    staticClass: "pa-2 text-sm"
  }, [_vm._v(" This order is being updated, the amount may be inaccurate ")])], 1)] : _vm._e(), _vm._v(" Total : " + _vm._s(_vm.formatPrice(_vm.order.total_amount_currency)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " * ")], 2), _c("div", {
    staticClass: "text-tax-info"
  }, [_vm.order.expedition_method === _vm.expeditionMethods.CELLAR_STORAGE.id ? [_c("div", [_vm._v(_vm._s(" duties & taxes free"))])] : _vm.isConcernedByVat ? [_vm.isGreatExport ? _c("div", [_vm._v(_vm._s(" incl. duty & tax"))]) : _c("div", [_vm._v(_vm._s(" incl. sales tax"))])] : [_c("div", [_vm._v(_vm._s(" incl. import duties & taxes"))]), _c("div", [_vm._v(_vm._s(" ex vat/gst"))])]], 2)]), _vm.order.credit_notes_amount_currency > 0 ? _c("div", {
    staticClass: "text-smaller"
  }, [_c("div", {
    staticClass: "order-maincontent-summary-linetotal-shipping text-right mb-1"
  }, [_vm._v(" Credits applied : "), _c("span", [_vm._v(" (-) " + _vm._s(_vm.formatPrice(_vm.order.credit_notes_amount_currency)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " ")])])]) : _vm._e(), ((_vm$order = _vm.order) === null || _vm$order === void 0 || (_vm$order = _vm$order.consultant) === null || _vm$order === void 0 ? void 0 : _vm$order.id_user) === +_vm.loggedUserData.idUser && _vm.order.amountConsultantCommissionCurrency > 0 ? _c("div", {
    staticClass: "order-maincontent-data-commission"
  }, [_vm._v(" My reward = "), _c("span", [[_vm._v(" " + _vm._s(_vm.formatPrice(_vm.order.amountConsultantCommissionCurrency)) + " ")], _vm._v(" " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " ")], 2)]) : _vm._e(), _vm._m(10)])], 2), _c("div", {
    staticClass: "order-maincontent-summary",
    class: [_vm.isFetchingShippingCosts && "--disabled"],
    attrs: {
      id: "order-summary"
    }
  }, [_c("h3", [_vm._v("Order Summary")]), _vm.isFetchingShippingCosts && (!_vm.groupedItemsRoot || !_vm.groupedItemsRoot.length) ? _vm._l(3, function (i) {
    return _c("div", {
      key: i
    }, [_c(VSkeletonLoader, {
      staticClass: "my-1",
      attrs: {
        width: "100%",
        type: "list-item-avatar-three-line"
      }
    })], 1);
  }) : _vm._l(_vm.groupedItemsRoot, function (groupedItems, ii) {
    var _vm$order$expedition_;
    return _c("div", {
      key: ii,
      attrs: {
        id: "order-summary-".concat(ii)
      }
    }, [_vm.isShippingEditable ? _c("h4", {
      staticClass: "my-2",
      attrs: {
        id: "items_" + _vm.getAnyShippingMethod(groupedItems).id
      }
    }, [_vm._v(" From "), _c("strong", [_vm._v(" " + _vm._s(_vm.getAnyShippingMethod(groupedItems).departureCountry) + " ")])]) : _vm._e(), _c("div", {
      staticClass: "order-maincontent-summary-items mt-4"
    }, [_vm._l(groupedItems, function (item) {
      var _item$wine, _item$wine2, _vm$tastingPhotos$req, _vm$tastingPhotos$req2;
      return _c("div", {
        key: item.id_item,
        staticClass: "item-row",
        class: [!_vm.isActiveItem(item) && "disabled-like", _vm.isCollapsed && "collapse"]
      }, [_c("div", {
        staticClass: "item-row-img"
      }, [!_vm.imagesBroken.includes(item.id_item) && (_item$wine = item.wine) !== null && _item$wine !== void 0 && _item$wine.imageThumbnail ? _c("img", {
        attrs: {
          src: item.wine.imageThumbnail,
          alt: ""
        },
        on: {
          error: function error($event) {
            return _vm.imagesBroken.push(item.id_item);
          }
        }
      }) : !_vm.imagesBroken.includes(item.id_item) && (_item$wine2 = item.wine) !== null && _item$wine2 !== void 0 && _item$wine2.image ? _c("img", {
        attrs: {
          src: item.wine.image,
          alt: ""
        },
        on: {
          error: function error($event) {
            return _vm.imagesBroken.push(item.id_item);
          }
        }
      }) : _c("img", {
        attrs: {
          src: require("@/assets/images/_temp/wine_default_primary_img.png"),
          alt: ""
        }
      })]), _c("div", {
        staticClass: "item-row-informations"
      }, [_c("div", {
        staticClass: "item-row-winename"
      }, [_c("router-link", {
        staticClass: "router-link",
        attrs: {
          to: _vm.productDetails(item.wine)
        }
      }, [_c("wine-naming", {
        key: "wine-naming-".concat(item.wine.id_wine),
        attrs: {
          wineNamingData: item.wine.naming_data,
          isPrefixWinery: true,
          isSuffixBottling: true,
          isSuffixType: true
        }
      })], 1)], 1), _c("div", {
        staticClass: "item-row-lineprices"
      }, [_c("div", {
        staticClass: "item-row-quantity"
      }, [_c("div", [_c("div", {
        staticClass: "item-row-lineprices-title"
      }, [_vm._v("Qty")]), _c("div", {
        staticClass: "item-row-lineprices-maindata"
      }, [_vm._v(" " + _vm._s(item.quantity / item.casingId.match(/\d+/)[0]) + " ")])])]), _c("div", {
        staticClass: "item-row-conditionment"
      }, [_c("div", [_c("div", {
        staticClass: "item-row-lineprices-title"
      }, [_vm._v("Casing")]), _c("div", {
        staticClass: "item-row-lineprices-maindata"
      }, [_vm._v(" " + _vm._s(_vm.casingWines.find(function (x) {
        return x.value == item.casingId;
      }).textCard) + " ")])])]), _c("div", {
        staticClass: "item-row-unitprice"
      }, [_c("div", [_c("div", {
        staticClass: "item-row-lineprices-title"
      }, [_vm._v("Case price")]), _c("div", {
        staticClass: "item-row-lineprices-maindata text-nowrap"
      }, [_vm._v(" " + _vm._s("".concat(_vm.formatPrice(_vm.getUnitPriceCurrencyForItem(item, _vm.order.expedition_method) * item.casingId.match(/\d+/)[0]), " ").concat(_vm.getSymbolCurrency(_vm.order.currency))) + " ")]), item.casingId !== "OC1" && item.casingId !== "OWC1" ? _c("div", {
        staticClass: "text-tax-info text-no-transform"
      }, [_vm._v(" " + _vm._s("".concat(_vm.formatPrice(_vm.getUnitPriceCurrencyForItem(item, _vm.order.expedition_method)), " ").concat(_vm.getSymbolCurrency(_vm.order.currency))) + " / bottle ")]) : _vm._e()])]), _c("div", {
        staticClass: "item-row-totalprice"
      }, [_c("div", {
        staticClass: "item-row-lineprices-title"
      }, [_vm._v("Total")]), _c("div", {
        staticClass: "item-row-lineprices-maindata text-nowrap"
      }, [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.getUnitPriceCurrencyForItem(item, _vm.order.expedition_method) * item.quantity)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " ")]), _c("div", {
        staticClass: "text-tax-info"
      }, [item.expeditionMethod === _vm.expeditionMethods.CELLAR_STORAGE.id ? [_c("div", [_vm._v(_vm._s(" duties & taxes free"))])] : _vm.isConcernedByVat ? [_vm.isGreatExport ? _c("div", [_vm._v(_vm._s(" incl. duty & tax"))]) : _c("div", [_vm._v(_vm._s(" incl. sales tax"))])] : [_c("div", [_vm._v(_vm._s(" incl. import duties & taxes"))]), _c("div", [_vm._v(_vm._s(" ex vat/gst"))])]], 2)]), (_vm$tastingPhotos$req = _vm.tastingPhotos.required.items) !== null && _vm$tastingPhotos$req !== void 0 && _vm$tastingPhotos$req.find(function (x) {
        var _x$order;
        return ((_x$order = x.order) === null || _x$order === void 0 ? void 0 : _x$order.itemId) === item.id_item;
      }) ? _c("div", {
        staticClass: "item-row-remove"
      }, [((_vm$tastingPhotos$req2 = _vm.tastingPhotos.required.items) === null || _vm$tastingPhotos$req2 === void 0 || (_vm$tastingPhotos$req2 = _vm$tastingPhotos$req2.find(function (x) {
        var _x$order2;
        return ((_x$order2 = x.order) === null || _x$order2 === void 0 ? void 0 : _x$order2.itemId) === item.id_item;
      })) === null || _vm$tastingPhotos$req2 === void 0 ? void 0 : _vm$tastingPhotos$req2.nbBottlesRemaining) > 0 ? _c("a", {
        staticClass: "fa fa-camera text-decoration-none icon-link",
        attrs: {
          title: "Add a new tasting photo"
        },
        on: {
          click: function click($event) {
            var _vm$tastingPhotos$req3;
            _vm.openTastingPhotoUploader((_vm$tastingPhotos$req3 = _vm.tastingPhotos.required.items) === null || _vm$tastingPhotos$req3 === void 0 ? void 0 : _vm$tastingPhotos$req3.find(function (x) {
              var _x$order3;
              return ((_x$order3 = x.order) === null || _x$order3 === void 0 ? void 0 : _x$order3.itemId) === item.id_item;
            }).id);
          }
        }
      }) : _vm._e()]) : _vm._e()]), !_vm.isActiveItem(item) && _vm.order.status < _vm.orderStatus.find(function (x) {
        return x.id == "AWAITING_VALIDATION";
      }).status ? _c("div", {
        staticClass: "errorLabel"
      }, [_vm._v(" This product is no longer available. "), !_vm.isOrderAwaitingCustomerValidation ? [_vm._v(" Please remove it. ")] : _c("a", {
        attrs: {
          href: "#"
        },
        on: {
          click: function click() {
            return _vm.dialogAdjustment.type = _vm.orderAdjustmentsTypes.USER_ASK_ADJUSTMENT.id, _vm.dialogAdjustment.visible = true;
          }
        }
      }, [_vm._v(" Please contact us. ")])], 2) : _vm._e()])]);
    }), groupedItems.length > 4 ? _c("div", {
      staticClass: "items-collapsis"
    }, [_vm.isCollapsed ? _c("div", {
      staticClass: "overlay"
    }) : _vm._e(), _vm.isCollapsed ? _c(VAlert, {
      staticClass: "--small",
      attrs: {
        dense: "",
        outlined: "",
        type: "info",
        text: ""
      }
    }, [_vm._v(" " + _vm._s("Click below to show the ".concat(groupedItems.length - 4, " other reference").concat(groupedItems.length - 4 > 1 ? "s" : "", " of this order")) + " ")]) : _vm._e(), _c(VBtn, {
      on: {
        click: function click($event) {
          return _vm.toogleCollapseItemsList(ii);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        dark: ""
      }
    }, [_vm._v(" " + _vm._s(_vm.isCollapsed ? "mdi-chevron-down" : "mdi-chevron-up") + " ")])], 1)], 1) : _vm._e(), !_vm.hasBeenValidated && _vm.adjustments.length > 0 && _vm.adjustments[0].message ? _c("div", {
      staticClass: "adjustment-last-message"
    }, [_c("div", [_vm._v("Last adjustment message")]), _c("div", {
      domProps: {
        innerHTML: _vm._s(_vm.adjustments.length > 0 ? String.nl2br(_vm.adjustments[0].message) : "")
      }
    })]) : _vm._e(), _vm.isShippingEditable ? _c("div", {
      staticClass: "order-maincontent-data-shippingmethod-edit --one-column"
    }, [_vm._m(11, true), _c("div", {
      class: _vm.isStoredInbound ? "disabled-group" : ""
    }, [_vm.expedition_methods.length === 0 || _vm.isFetchingShippingCosts ? _c(VSkeletonLoader, {
      attrs: {
        width: "100%",
        type: "heading"
      }
    }) : [_vm.isShippingInErrorEvenSuperAdmin() ? [_c("div", {
      staticClass: "flex"
    }, [_c(VAlert, {
      staticClass: "--small",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "red",
        text: ""
      }
    }, [_vm._v(" There is no shipping method available. Please contact our "), _c("router-link", {
      staticClass: "router-link",
      attrs: {
        to: {
          name: "userContact"
        }
      }
    }, [_vm._v(" Customer Services. ")])], 1)], 1)] : _vm.isShippingOutOfRange() ? [_c("div", {
      staticClass: "flex"
    }, [_c(VAlert, {
      staticClass: "--small",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "orange",
        text: ""
      }
    }, [_vm._v(" " + _vm._s(_vm.getShippingOutOfRangeMessage()) + " ")])], 1)] : _c(VBtnToggle, {
      staticClass: "btn-group",
      attrs: {
        tile: "",
        group: "",
        mandatory: _vm.getAnyGroupedItem(groupedItems).shippingMethods.length === 1,
        items: _vm.expedition_methods
      },
      model: {
        value: _vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId],
        callback: function callback($$v) {
          _vm.$set(_vm.order.expedition_methods, _vm.getAnyShippingMethod(groupedItems).departureWarehouseId, $$v);
        },
        expression: "\n                          order.expedition_methods[\n                            getAnyShippingMethod(groupedItems).departureWarehouseId\n                          ]\n                        "
      }
    }, [_vm._l(_vm.getAnyGroupedItem(groupedItems).shippingMethods, function (shipItem) {
      return [_c(VBtn, {
        key: shipItem.id,
        staticClass: "btn-group-btn btn-ship-choice",
        attrs: {
          value: shipItem,
          disabled: _vm.isProcessingPayment || (_vm.isStoredInbound || _vm.order.stockTransferIsAskedByUser) && shipItem.id === _vm.expeditionMethods.CELLAR_STORAGE.id
        },
        on: {
          click: function click($event) {
            return _vm.changeExpeditionMethod(shipItem, groupedItems);
          }
        }
      }, [_c("div", [_c("div", [_c("i", {
        class: "fas ".concat(shipItem.icon)
      }), _vm._v(" " + _vm._s(shipItem.label) + " ")]), shipItem.id === _vm.expeditionMethods.CELLAR_STORAGE.id ? [_c("div", {
        staticClass: "btn-ship-choice-important-data"
      }, [_vm._v(" " + _vm._s(_vm.isStoredInbound ? "Incompatible with inbound process" : "Manage the pickup on my own") + " ")]), _c("div", {
        staticClass: "btn-ship-choice-important-data"
      }, [_vm._v(" Shipping & tax free ")])] : [_c("div", {
        staticClass: "btn-ship-choice-important-data"
      }, [_vm._v(" ETA : " + _vm._s(shipItem.eta_label) + " ")]), _c("div", {
        staticClass: "btn-ship-choice-important-data",
        domProps: {
          innerHTML: _vm._s(_vm.showShippingPriceMinusDefault(shipItem, _vm.order.items, _vm.order.currency))
        }
      })]], 2)])];
    })], 2), _vm.errorLabels.shipping[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId] ? _c("div", {
      staticClass: "errorLabel"
    }, [_vm._v(" " + _vm._s(_vm.errorLabels.shipping[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId]) + " ")]) : _vm._e(), !_vm.isShippingInError && _vm.order.expedition_methods[_vm.order.id_warehouse] && _vm.order.expedition_methods[_vm.order.id_warehouse].id !== _vm.expeditionMethods.CELLAR_STORAGE.id ? _c("div", {
      staticClass: "eta text-left"
    }, [_c("div", [_vm._v(" Estimated time of arrival, from warehouse departure : "), _c("strong", [_vm._v(" " + _vm._s(_vm.getEtaLabel(_vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId].eta_min_hours, _vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId].eta_max_hours)) + " ")])])]) : _vm._e()]], 2), ((_vm$order$expedition_ = _vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId]) === null || _vm$order$expedition_ === void 0 ? void 0 : _vm$order$expedition_.id) === _vm.expeditionMethods.CELLAR_STORAGE.id ? _c("div", {
      staticClass: "mt-3"
    }, [_vm._m(12, true), _c("StorageTermsReference")], 1) : _vm._e()]) : _vm._e()], 2), _c("div", {
      staticClass: "order-maincontent-summary-linetotal"
    }, [_c("div", {
      staticClass: "order-maincontent-summary-linetotal-shipping"
    }, [!_vm.isShippingEditable && _vm.order.expedition_method === _vm.expeditionMethods.CELLAR_STORAGE.id ? [_c("span", {
      staticClass: "free-storage-text"
    }, [_vm._v("Free storage for 3 months.")]), _c("br"), _vm._v(" A notification asking you to collect your goods will be sent to you every month "), _c("strong", [_vm._v("for 2 months")]), _vm._v(" , then every week "), _c("strong", [_vm._v("for the last month.")])] : _vm._e()], 2)]), _vm.order.credit_notes.length > 0 ? _c("div", {
      staticClass: "credit-note-list --no-before"
    }, [_c(VExpansionPanels, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("Credits Applied")]), _c(VExpansionPanelContent, [_c("div", {
      staticClass: "order-maincontent-summary-items"
    }, _vm._l(_vm.order.credit_notes, function (item) {
      return _c("div", {
        key: item.id,
        staticClass: "item-row-credit-note"
      }, [_c("div", {
        staticClass: "item-row-informations"
      }, [_c("div", {
        staticClass: "item-row-numberlabel"
      }, [_c("span", [_vm._v(" " + _vm._s(item.customerNumberLabel) + " ")])]), _c("div", {
        staticClass: "item-row-lineprices"
      }, [_c("div", [_vm._v(" " + _vm._s(_vm.formatPrice(item.amountCurrency)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " ")])])]), _c("div")]);
    }), 0)])], 1)], 1)], 1) : _vm._e()]);
  }), _c("div", {
    staticClass: "--one-column"
  }, [_c(VDivider, {
    staticClass: "my-5"
  }), !_vm.isShippingEditable ? _c("div", {
    staticClass: "order-maincontent-summary-linetotal-shipping text-right mb-1"
  }, [_c("div", [_vm._v("Shipping type : " + _vm._s(_vm.order.shipmentLabel))]), _vm.order.amount_shipping_currency > 0 ? [_vm.order.amountShippingNotIncludedInItemsCurrency > 0 ? _c("div", [_vm.hasBeenPricePostedWithProperShippingFees ? [_vm._v(" Shipping fee "), _c("span", [_vm._v(" : " + _vm._s(_vm.order.nbRegularBottlesForShipping) + " x " + _vm._s(_vm.formatPrice(_vm.order.amountShippingNotIncludedInItemsCurrency / _vm.order.nbRegularBottlesForShipping)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " ")]), _c("span", [_vm._v(" = " + _vm._s(_vm.formatPrice(_vm.order.amountShippingNotIncludedInItemsCurrency)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " ")])] : [_vm._v(" Shipping fee "), _c("span", [_vm._v(" + " + _vm._s(_vm.formatPrice(_vm.order.amountShippingNotIncludedInItemsCurrency / _vm.nbBottles)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " / bottle ")])]], 2) : _c("div", [_vm._v("Free shipping")])] : _vm._e()], 2) : _vm._e(), _c("div", {
    staticClass: "order-maincontent-data-total"
  }, [_c("div", {
    staticClass: "text-center"
  }, [!_vm.order.isFullyCalculatedAmounts ? [_c(VMenu, {
    attrs: {
      "open-on-hover": "",
      top: "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref4) {
        var on = _ref4.on,
          attrs = _ref4.attrs;
        return [_c(VIcon, _vm._g(_vm._b({
          attrs: {
            color: "orange darken-2"
          }
        }, "v-icon", attrs, false), on), [_vm._v("mdi-alert")])];
      }
    }], null, false, 4104483039)
  }, [_c(VCard, {
    staticClass: "pa-2 text-sm"
  }, [_vm._v(" This order is being updated, the amount may be inaccurate ")])], 1)] : _vm._e(), _vm._v(" Total : " + _vm._s(_vm.formatPrice(_vm.order.total_amount_currency)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " * ")], 2), _c("div", {
    staticClass: "text-tax-info"
  }, [_vm.order.expedition_method === _vm.expeditionMethods.CELLAR_STORAGE.id ? [_c("div", [_vm._v(_vm._s(" duties & taxes free"))])] : _vm.isConcernedByVat ? [_vm.isGreatExport ? _c("div", [_vm._v(_vm._s(" incl. duty & tax"))]) : _c("div", [_vm._v(_vm._s(" incl. sales tax"))])] : [_c("div", [_vm._v(_vm._s(" incl. import duties & taxes"))]), _c("div", [_vm._v(_vm._s(" ex vat/gst"))])]], 2)]), _vm.order.credit_notes_amount_currency > 0 ? _c("div", {
    staticClass: "text-smaller"
  }, [_c("div", {
    staticClass: "order-maincontent-summary-linetotal-shipping text-right mb-1"
  }, [_vm._v(" Credits applied : "), _c("span", [_vm._v(" (-) " + _vm._s(_vm.formatPrice(_vm.order.credit_notes_amount_currency)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " ")])])]) : _vm._e(), ((_vm$order2 = _vm.order) === null || _vm$order2 === void 0 || (_vm$order2 = _vm$order2.consultant) === null || _vm$order2 === void 0 ? void 0 : _vm$order2.id_user) === +_vm.loggedUserData.idUser && _vm.order.amountConsultantCommissionCurrency > 0 ? _c("div", {
    staticClass: "order-maincontent-data-commission"
  }, [_vm._v(" My reward = "), _c("span", [[_vm._v(" " + _vm._s(_vm.formatPrice(_vm.order.amountConsultantCommissionCurrency)) + " ")], _vm._v(" " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " ")], 2)]) : _vm._e(), _vm._m(13)], 1)], 2)])]), _vm.order.items.length != 0 || _vm.isOrderAwaitingCustomerValidation ? _c("div", {
    staticClass: "order-bottom-content container-centered small"
  }, [_vm.order.items.length != 0 ? _c("div", {
    staticClass: "order-bottom-content-incoterms"
  }, [_vm._m(14)]) : _vm._e(), _vm.isOrderAwaitingCustomerValidation && _vm.order.items.length > 0 ? _c("div", {
    staticClass: "order-bottom-content-acceptterms"
  }, [_c("WholesalersData", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  }), _c(VCheckbox, {
    attrs: {
      "data-cy": "order-basket-agree-brand-checkbox"
    },
    model: {
      value: _vm.checkboxCGV,
      callback: function callback($$v) {
        _vm.checkboxCGV = $$v;
      },
      expression: "checkboxCGV"
    }
  }, [_c("div", {
    staticClass: "order-bottom-content-acceptterms-label",
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(" I agree with the " + _vm._s(_vm.$whitelabel.brand) + " " + _vm._s(" ") + " "), _c("a", {
    on: {
      click: function click($event) {
        return _vm.openToS();
      }
    }
  }, [_vm._v("terms of sales")]), _vm._v(" . ")])]), _c("div", {
    staticClass: "order-bottom-content-acceptterms-certifylaw"
  }, [_c(VCheckbox, {
    attrs: {
      "data-cy": "order-basket-agree-laws-checkbox"
    },
    model: {
      value: _vm.checkboxLawCompliance,
      callback: function callback($$v) {
        _vm.checkboxLawCompliance = $$v;
      },
      expression: "checkboxLawCompliance"
    }
  }, [_c("div", {
    staticClass: "order-bottom-content-acceptterms-certifylaw-label",
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(" I certify that I am aware of the laws governing my place of residence and that I am complying with them. ")])])], 1), ((_vm$itemsRequiringTas = _vm.itemsRequiringTastingPhoto) === null || _vm$itemsRequiringTas === void 0 ? void 0 : _vm$itemsRequiringTas.length) > 0 ? _c("div", {
    staticClass: "order-bottom-content-acceptterms-tastingPhoto-container"
  }, _vm._l(_vm.itemsRequiringTastingPhoto, function (itemRequiring) {
    return _c("div", {
      key: "tastingPhoto-chkbox-" + itemRequiring.id_item,
      staticClass: "order-bottom-content-acceptterms-tastingPhoto"
    }, [_c(VCheckbox, {
      model: {
        value: _vm.checkboxTastingPhoto[itemRequiring.id_item],
        callback: function callback($$v) {
          _vm.$set(_vm.checkboxTastingPhoto, itemRequiring.id_item, $$v);
        },
        expression: "checkboxTastingPhoto[itemRequiring.id_item]"
      }
    }, [_c("div", {
      staticClass: "order-bottom-content-acceptterms-tastingPhoto-label",
      attrs: {
        slot: "label"
      },
      slot: "label"
    }, [_vm._v(" I notified the restaurant to take a photo of each bottle of «" + _vm._s(_vm.wineNaming(_vm.$whitelabel, itemRequiring.wine.naming_data, true, true, true)) + "» at the time of its tasting. ")])])], 1);
  }), 0) : _vm._e(), _vm.errorLabels.cgv.length > 0 ? _c("div", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.cgv) + " ")]) : _vm._e(), _vm.errorLabels.tastingPhoto.length > 0 ? _c("div", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.tastingPhoto) + " ")]) : _vm._e(), !!Object.values(_vm.errorLabels.shipping).length ? _c("div", {
    staticClass: "errorLabel"
  }, [_vm._v(" A shipping type is missing on some items ")]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm.order.items.length > 0 ? _c("div", {
    staticClass: "button-end-page-container"
  }, [_vm.isOrderAwaitingCustomerValidation || !_vm.hasBeenValidated ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      loading: _vm.isDecliningOrder,
      disabled: _vm.isFinalizingOrder,
      rounded: true
    },
    on: {
      click: function click() {
        return _vm.dialogAdjustment.type = _vm.orderAdjustmentsTypes.USER_DECLINE.id, _vm.dialogAdjustment.visible = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isOrderAwaitingCustomerValidation ? "Decline order" : "Cancel order") + " ")]) : _vm._e(), _vm.isOrderAwaitingCustomerValidation ? [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      disabled: _vm.isDecliningOrder || _vm.isFinalizingOrder,
      rounded: true
    },
    on: {
      click: function click() {
        return _vm.dialogAdjustment.type = _vm.orderAdjustmentsTypes.USER_ASK_ADJUSTMENT.id, _vm.dialogAdjustment.visible = true;
      }
    }
  }, [_vm._v(" Ask for adjustments ")]), _vm.order.payments.length ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      loading: _vm.isFinalizingOrder,
      disabled: _vm.isDecliningOrder || !_vm.order.expedition_method,
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.userValidateOrder();
      }
    }
  }, [_vm._v(" Confirm order ")]) : [!_vm.isImporterPreventPayment && !_vm.isStoredInbound ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      disabled: _vm.isDecliningOrder || !_vm.order.expedition_method,
      rounded: true,
      loading: _vm.isProcessingPayment
    },
    on: {
      click: function click($event) {
        return _vm.continueToPayment();
      }
    }
  }, [_vm._v(" Continue to payment ")]) : _vm._e(), _vm.isAllowedOrderWithoutPayment() || _vm.isImporterPreventPayment || _vm.isStoredInbound ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      disabled: _vm.isDecliningOrder || !_vm.order.expedition_method,
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.userValidateOrderWithoutPayment();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isImporterPreventPayment || _vm.isStoredInbound ? "Confirm order" : "Order without set payment") + " ")]) : _vm._e()]] : _vm._e()], 2) : _vm._e(), _c(VDialog, {
    attrs: {
      persistent: "",
      width: "600px"
    },
    model: {
      value: _vm.dialogAdjustment.visible,
      callback: function callback($$v) {
        _vm.$set(_vm.dialogAdjustment, "visible", $$v);
      },
      expression: "dialogAdjustment.visible"
    }
  }, [_vm.dialogAdjustment.type ? _c(VCard, {
    staticClass: "dialog-adjustment-card"
  }, [_c(VCardTitle, {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.dialogAdjustmentData.title))]), _c(VCardText, [_vm.dialogAdjustment.type != "history" ? _c("textarea", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.dialogAdjustment.message,
      expression: "dialogAdjustment.message"
    }],
    staticClass: "w100p",
    attrs: {
      "hide-details": "auto",
      placeholder: _vm.dialogAdjustmentData.message_placeholder
    },
    domProps: {
      value: _vm.dialogAdjustment.message
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.dialogAdjustment, "message", $event.target.value);
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.errorLabels.adjustment.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.adjustment) + " ")]) : _vm._e(), _vm.dialogAdjustment.historicVisible || _vm.dialogAdjustment.type === "history" ? _c("div", {
    staticClass: "adjustment-historic"
  }, _vm._l(_toConsumableArray(_vm.adjustments).reverse(), function (adjustment, i) {
    var _vm$order$consultant;
    return _c("div", {
      key: "adjustment-" + i,
      staticClass: "adjustment-historic-item",
      class: adjustment.senderUserId === _vm.order.id_user || adjustment.senderUserId === ((_vm$order$consultant = _vm.order.consultant) === null || _vm$order$consultant === void 0 ? void 0 : _vm$order$consultant.id_user) ? "--by-me" : ""
    }, [_c("div", {
      staticClass: "adjustment-historic-item-date"
    }, [_vm._v(" " + _vm._s(_vm._f("formatDateTime")(adjustment.sendDate)) + " ")]), _c("div", {
      staticClass: "adjustment-historic-item-content"
    }, [_c("div", {
      staticClass: "adjustment-historic-item-content-title"
    }, [_vm._v(" " + _vm._s(Object.values(_vm.orderAdjustmentsTypes).find(function (x) {
      return x.id === adjustment.actionType;
    }).textUser) + " ")]), adjustment.message ? _c("div", {
      staticClass: "adjustment-historic-item-content-message",
      domProps: {
        innerHTML: _vm._s(String.nl2br(adjustment.message))
      }
    }) : _vm._e()])]);
  }), 0) : _vm._e()]), _c(VCardActions, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      loading: _vm.isCreatingAdjustment
    },
    on: {
      click: function click($event) {
        _vm.isDecliningOrder = false;
        _vm.isFinalizingOrder = false;
        _vm.dialogAdjustment.visible = false;
      }
    }
  }, [_vm._v(" Close ")]), _vm.dialogAdjustment.type !== "history" ? [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      loading: _vm.isCreatingAdjustment,
      disabled: _vm.dialogAdjustment.type === _vm.orderAdjustmentsTypes.ADMIN_DECLINE.id
    },
    on: {
      click: function click($event) {
        return _vm.dialogAdjustmentAction();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.dialogAdjustmentData.cta_label) + " ")]), _vm.adjustments.length > 0 ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        _vm.dialogAdjustment.historicVisible = !_vm.dialogAdjustment.historicVisible;
      }
    }
  }, [_vm._v(" History ")]) : _vm._e()] : _vm._e()], 2)], 1) : _vm._e()], 1), _vm.tastingPhotos.upload.isComponentCreated ? _c("TastingPhotoUploadFormModal", {
    ref: "tastingPhotoUploadForm",
    attrs: {
      loggedUserData: _vm.loggedUserData,
      tastingPhotoRequiredId: _vm.tastingPhotos.upload.tastingPhotoRequiredId
    },
    on: {
      closed: function closed($event) {
        return _vm.closeTastingPhotoUploader();
      }
    }
  }) : _vm._e(), _c("confirm", {
    ref: "confirm"
  })]], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-dolly"
  }), _vm._v(" Pickup ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-battery-three-quarters"
  }), _vm._v(" Status ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-user"
  }), _vm._v(" Deliver to ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-phone"
  }), _vm._v(" Contacts ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "far fa-clock"
  }), _vm._v(" Payment terms ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-truck"
  }), _vm._v(" Shipping type ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-map-marked-alt"
  }), _vm._v(" Billing address ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-map-marked"
  }), _vm._v(" Delivery address ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-map-marked-alt"
  }), _vm._v(" Billing address ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-truck-loading"
  }), _vm._v(" Delivery instructions ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "order-maincontent-summary-extrainformations"
  }, [_c("div", [_c("i", {
    staticClass: "fas fa-shield-alt"
  }), _vm._v(" 100% secure payments ")]), _c("div", [_c("i", {
    staticClass: "fas fa-check-circle"
  }), _vm._v(" Guaranteed origin products ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-truck"
  }), _vm._v(" Shipping type ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("span", {
    staticClass: "free-storage-text"
  }, [_vm._v("Free storage for 3 months.")]), _c("br"), _vm._v(" A notification asking to collect the goods will be sent every month "), _c("strong", [_vm._v("for 2 months")]), _vm._v(" , then every week "), _c("strong", [_vm._v("for the last month.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "order-maincontent-summary-extrainformations"
  }, [_c("div", [_c("i", {
    staticClass: "fas fa-shield-alt"
  }), _vm._v(" 100% secure payments ")]), _c("div", [_c("i", {
    staticClass: "fas fa-check-circle"
  }), _vm._v(" Guaranteed origin products ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "text-incoterms"
  }, [_vm._v(" *Sold in delivered duty paid incoterm only if you have not selected stored in the cellar. Delivered duty paid is a delivery agreement whereby the seller assumes all of the responsibility, risk, and costs associated with transporting goods until the buyer receives or transfers them at the destination port. This agreement includes paying for shipping costs, export and import duties, insurance, and any other expenses incurred during shipping to an agreed-upon location in the buyer's country. ")]), _c("div", {
    staticClass: "text-incoterms"
  }, [_vm._v("All items are subject to availability.")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };